import { render } from "./CoopModal.vue?vue&type=template&id=34aa1154&scoped=true"
import script from "./CoopModal.vue?vue&type=script&lang=js"
export * from "./CoopModal.vue?vue&type=script&lang=js"

import "./CoopModal.vue?vue&type=style&index=0&id=34aa1154&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aa1154"]])

export default __exports__